$(document).ready(function(){
  var $contactFormContent = $(".contact_form_content");

  if(localStorage.getItem("event_btn")=='yes'){
          
      if ($contactFormContent.length) {
        setTimeout(function(){
          $('html, body').animate({
              scrollTop: $contactFormContent.offset().top - 150
          },2000);
        }, 2500);
          
      } else {
          console.error("Target element not found or not visible.");
      }
      // $('html, body').animate({
      //   scrollTop: $(".contact_form_content").offset().top - 150
      // });
    localStorage.removeItem("event_btn");
  }
    
  $('.events_single_btn').click(function(){
    localStorage.setItem("event_btn", "yes");
    
    var page_url = $(this).attr('data-href');
    window.location.href = page_url; 
  })

  // ==================================================================

  
  $('.see_more_products').click(function(){
    
      $(this).parents('.serch_bar_product').find('button[type="submit"]').trigger('click');
      
  });

  // =====================================================

 
  var product_faq_time = setInterval(function () {

  var product_faq_length = $('.product_faqs div').length;
    
    if(product_faq_length > 0)
    {
        clearInterval(product_faq_time);
    }
 $('.product_faq_question').each(function() {
      const $item = $(this);
      const $answer = $item.next();
  
      $item.on('click', function() {
        
          $('.product_faq_question').not($item).removeClass('active_heading');
          $('.product_faq_question').not($item).next().removeClass('active').css('max-height', '0');
  
          $answer.toggleClass('active');
          $item.toggleClass('active_heading');
  
          if ($answer.hasClass('active')) {
              // $answer.css('max-height', $answer.prop('scrollHeight') + "px");
            $answer.css('max-height', "1500px");
          } else {
              $answer.css('max-height', '0');
          }
      });
  
      if ($answer.hasClass('active')) {
          $answer.css('max-height', $answer.prop('scrollHeight') + "px");
      }
  });
    
    
  },3000);
  

  

  
//   document.addEventListener("DOMContentLoaded", function(event) { 

//   const faqItems = document.querySelectorAll('.product_faq_question');
 
//   faqItems.forEach(item => {
    
//     const answer = item.nextElementSibling;
//     item.addEventListener('click', () => {

//       faqItems.forEach(otherItem => {
        
//         if (otherItem !== item) 
//         {
//           const otherAnswer = otherItem.nextElementSibling;

//           // const otherIcon = otherItem.querySelector('.product_faq_question');
//           otherItem.classList.remove('active_heading');
//           otherAnswer.classList.remove('active');
        
//           otherAnswer.style.maxHeight = "0";
//         }
//       });
      
//       answer.classList.toggle('active');
//       item.classList.toggle('active_heading');
//       if (answer.classList.contains('active')) 
//       {
//         answer.style.maxHeight = answer.scrollHeight + "px";
//       } 
//       else 
//       {
//         answer.style.maxHeight = "0";
//       }
//     });

//     if (answer.classList.contains('active')) 
//     {
//       answer.style.maxHeight = answer.scrollHeight + "px";
//     } 
    
//   });
// });
});

/* Fix: Lazy loading for dynamically-added images (v2)
 * jquery.lazyload v1.9.1 only tracks images present at init time.
 * The Globo Also Bought app (Mix & Match carousel) renders product
 * images AFTER lazyload initializes, so those images keep showing
 * the load_small.jpg placeholder forever.
 *
 * This fix uses three strategies:
 * 1. MutationObserver catches images added after this script runs
 * 2. Initial scan catches images already in DOM but missed by lazyload
 * 3. Periodic retry (3x over 6s) catches late-rendered images
 */
(function() {
  if (typeof IntersectionObserver === "undefined") return;

  var lazyIO = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var img = entry.target;
      var src = img.getAttribute("data-src");
      if (src) {
        img.src = src;
        img.removeAttribute("data-src");
        img.classList.remove("lazy");
      }
      lazyIO.unobserve(img);
    });
  }, { rootMargin: "300px" });

  function scanLazyImages() {
    var imgs = document.querySelectorAll("img.lazy[data-src]");
    for (var i = 0; i < imgs.length; i++) {
      lazyIO.observe(imgs[i]);
    }
    return imgs.length;
  }

  /* Strategy 1: MutationObserver for future DOM additions */
  if (typeof MutationObserver !== "undefined") {
    var mo = new MutationObserver(function(mutations) {
      var found = false;
      mutations.forEach(function(mutation) {
        for (var i = 0; i < mutation.addedNodes.length; i++) {
          var node = mutation.addedNodes[i];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches("img.lazy[data-src]")) {
            lazyIO.observe(node);
            found = true;
          }
          if (node.querySelectorAll) {
            var imgs = node.querySelectorAll("img.lazy[data-src]");
            for (var j = 0; j < imgs.length; j++) {
              lazyIO.observe(imgs[j]);
              found = true;
            }
          }
        }
      });
    });
    mo.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  /* Strategy 2: Initial scan for images already in DOM */
  scanLazyImages();

  /* Strategy 3: Periodic retry for late-rendered content */
  var retries = 0;
  var retryInterval = setInterval(function() {
    scanLazyImages();
    retries++;
    if (retries >= 5) clearInterval(retryInterval);
  }, 2000);
})();